import { render, staticRenderFns } from "./JobReportList.vue?vue&type=template&id=e48dac2e&"
import script from "./JobReportList.vue?vue&type=script&lang=js&"
export * from "./JobReportList.vue?vue&type=script&lang=js&"
import style0 from "./JobReportList.vue?vue&type=style&index=0&id=e48dac2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports